export default __webpack_public_path__ + "static/media/banner3.931766c1.jpg";